module.exports = __webpack_public_path__ + "static/media/unsupported_file.288cd945.webp";